// extracted by mini-css-extract-plugin
export var mediaContainer = "media-module--mediaContainer--17EiB";
export var image = "media-module--image--38k4_";
export var video = "media-module--video--13_4I";